import client from '../base-api';

const serviceURL = '/office';

const officeService = {

    getOffices(filterData: any) {
        return client.get(`${serviceURL}`, {params: filterData});
    },

    getOffice(officeId: number) {
        return client.get(`${serviceURL}/${officeId}`);
    },

    postOffice(officeData: any) {
        return client.post(`${serviceURL}`, officeData);
    },

    putOffice(officeData: any, officeId: number) {
        return client.put(`${serviceURL}/${officeId}`, officeData);
    },

    activateOffice(officeId: number) {
        return client.post(`${serviceURL}/${officeId}/activate`);
    },

    closeOffice(officeId: number) {
        return client.post(`${serviceURL}/${officeId}/close`);
    },

    deleteOffice(officeId: number) {
        return client.delete(`${serviceURL}/${officeId}`);
    },

    getExportOffice(officeId: number) {
        return client.get(`${serviceURL}/excel/export/${officeId}`);
    },
}

export default officeService;